import { render, staticRenderFns } from "./Decorations.vue?vue&type=template&id=6e560de0&scoped=true&lang=pug&"
import script from "./Decorations.vue?vue&type=script&lang=js&"
export * from "./Decorations.vue?vue&type=script&lang=js&"
import style0 from "./Decorations.vue?vue&type=style&index=0&id=6e560de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e560de0",
  null
  
)

export default component.exports